export const getValueFromStorage = key => localStorage.getItem(key);

export const setValueToStorage = (key, value) => localStorage.setItem(key, value);

export const removeValueFromStorage = key => localStorage.removeItem(key);
